
const $ = jQuery.noConflict();

'use strict';
const EqualHeights = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeight();
	},

	/** @description slider example description e.g Banner slider */
	equalHeightsGlobal: (elm) => {
		let x = 0;
		elm.height('auto');

		elm.each((index, el) => {
			if ($(el).height() > x) {
				x = $(el).height();
			}
		});

		elm.height(x + 1);
	},

	equalHeight: ()=> {
		EqualHeights.equalHeightsGlobal($('.equal-heights'));

		$(window).on('resize', function() {
			EqualHeights.equalHeightsGlobal($('.equal-heights'));
		});

		$(window).on('load', function() {
			EqualHeights.equalHeightsGlobal($('.equal-heights'));
		});
		$(window).on('load', function() {
			EqualHeights.equalHeightsGlobal($('.contact-us__left-box-title'));
		});
	},
};

export default EqualHeights;